// Refine
import { useNotification, useTranslation } from '@refinedev/core';

// React Query
import { useMutation } from '@tanstack/react-query';

import type { UseMutationResult } from '@tanstack/react-query';

// Utils
import { postRequest as post } from '../utils/HttpMethods';

export type RemittanceType = 'BC' | 'MB' | 'MSH' | 'QDOC' | 'WCB' | 'SK';

interface ProcessRemittanceParams {
  remittanceFile?: string;
  incomeFile?: string;
  returnFile?: string;
  userID: string;
  siteID: string;
  type: RemittanceType;
}

export interface ProcessRemittanceResponse {
  statusCode: number;
  message: string;
}

const processRemittance = async (
  {
    remittanceFile,
    incomeFile,
    returnFile,
    userID,
    siteID,
    type,
  }: ProcessRemittanceParams,
  errorMessage: string
): Promise<ProcessRemittanceResponse> => {
  const data: ProcessRemittanceResponse = await post(
    'QBilling',
    `/action/parse/remittance`,
    {
      remittanceFile,
      incomeFile,
      returnFile,
      siteID,
      userID,
      type,
    }
  );
  if (!data) {
    throw new Error(errorMessage);
  }
  return data;
};

export const useProcessRemittance = (): UseMutationResult<
  ProcessRemittanceResponse,
  Error
> => {
  const { open } = useNotification();
  const { translate } = useTranslation();
  return useMutation({
    mutationFn: (params: ProcessRemittanceParams) =>
      processRemittance(params, translate('pages:remittances.upload.failed')),
    onSuccess: () => {
      open?.({
        message: translate('pages:remittances.upload.processing'),
        type: 'success',
      });
    },
  });
};
